import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAN5Av-Aodxy2J2Hy46fVr4DkrhjEGRGDM",
  authDomain: "sejkansyncauth.firebaseapp.com",
  projectId: "sejkansyncauth",
  storageBucket: "sejkansyncauth.firebasestorage.app",
  messagingSenderId: "265719764448",
  appId: "1:265719764448:web:15c3d9161189e1e73a0785"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
